import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { l, palettes } from '@manychat/manyui'

import NextStepSelectItem from 'common/builder/components/builder/NextStepSelectItem'
import NodePicker from 'common/builder/components/builder/NodePicker'

export default class NodePickerNextStepSelectItem extends Component {
  static propTypes = {
    builderId: PropTypes.string,
    sourceId: PropTypes.string,
    onSelectNode: PropTypes.func.isRequired,
  }

  state = {
    showPicker: false,
  }

  showPicker = () => {
    this.setState({ showPicker: true })
  }

  hidePicker = () => {
    this.setState({ showPicker: false })
  }

  handleSelect = (nodeId) => {
    this.props.onSelectNode(nodeId)
    this.hidePicker()
  }

  render() {
    const { builderId, sourceId } = this.props

    return (
      <span>
        <NextStepSelectItem
          onSelect={this.showPicker}
          icon="OrphanBuilderSelect"
          color={palettes.semantic.primary}
          title={l.translate('Select Existing Step')}
        />
        <NodePicker
          builderId={builderId}
          sourceId={sourceId}
          onSelect={this.handleSelect}
          onClose={this.hidePicker}
          open={this.state.showPicker}
        />
      </span>
    )
  }
}
